import { useState } from "react";

// this hook will be utilize when managing drawer, modal, pop up, dialog box

const useOverlayState = () => {
  const [OverlayState, setOverlayState] = useState({
    visible: false,
    OverlayName: "",
    record: undefined,
    mode: undefined, // edit create view
    messages: undefined,
  });

  const openOverlay = ({ OverlayName, record, mode, messages }) => {
    setOverlayState({
      visible: true,
      OverlayName: OverlayName || "",
      record: record,
      mode: mode,
      messages,
    });
  };

  const closeOverlay = () => {
    setOverlayState({
      visible: false,
      OverlayName: "",
      record: undefined,
      mode: undefined,
      messages: undefined,
    });
  };

  return { OverlayState, openOverlay, closeOverlay };
};

export default useOverlayState;
